NewStudyController.$inject = ['StudyService', 'AppService', '$uibModal', '$transitions', '$scope']

export default function NewStudyController(StudyService, AppService, $uibModal, $transitions, $scope) {
  var vm = this

  function saveSelection() {
    if (window.getSelection) {
      sel = window.getSelection()
      if (sel.getRangeAt && sel.rangeCount) {
        var ranges = []
        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
          ranges.push(sel.getRangeAt(i))
        }
        return ranges
      }
    } else if (document.selection && document.selection.createRange) {
      return document.selection.createRange()
    }
    return null
  }

  vm.study = StudyService.initStudy()

  vm.insertLink = function() {
    AppService.savedSel = saveSelection()

    $uibModal.open({
      controller: 'ModalLinkController',
      controllerAs: 'modalLink',
      template: require('../../app/link-modal-new.html')
    }).result.then(angular.noop, angular.noop)
  }
  vm.setPromoted = function() {
    vm.study.isPromoted = !vm.study.isPromoted
  }
  vm.setPublished = function() {
    vm.study.isPublished = !vm.study.isPublished
  }
  $transitions.onBefore({}, () => {
    if (!vm.cancelled && !$scope.pristine.isPristine()) return StudyService.postStudy(vm.study)
  }, {invokeLimit: 1})
}